import { render, staticRenderFns } from "./educationCoursePop.vue?vue&type=template&id=71c83cd5"
import script from "./educationCoursePop.vue?vue&type=script&lang=js"
export * from "./educationCoursePop.vue?vue&type=script&lang=js"
import style0 from "./educationCoursePop.vue?vue&type=style&index=0&id=71c83cd5&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c83cd5')) {
      api.createRecord('71c83cd5', component.options)
    } else {
      api.reload('71c83cd5', component.options)
    }
    module.hot.accept("./educationCoursePop.vue?vue&type=template&id=71c83cd5", function () {
      api.rerender('71c83cd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/cc/educationCoursePop.vue"
export default component.exports